import React, { useState, useEffect } from 'react';
import useScrollToTop from '../components/useScrollToTop.js';

const PriceCalculator = ({ orderAmount, paymentModal }) => {
    useScrollToTop();
    const [totalPrice, setTotalPrice] = useState(0);
    const [pickupCharge, setPickupCharge] = useState(0);
    const [handlingFee, setHandlingFee] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [discountPercentage, setDiscountPercentage] = useState(0);

    useEffect(() => {
        const calculatedPickupCharge = orderAmount * 0.60;
        const calculatedHandlingFee = orderAmount * 0.10;
        const calculatedTotalPrice = Number(orderAmount * 1.30) + calculatedPickupCharge + calculatedHandlingFee;
        const calculatedDiscount = calculatedTotalPrice - orderAmount;

        setTotalPrice(calculatedTotalPrice);
        setPickupCharge(calculatedPickupCharge);
        setHandlingFee(calculatedHandlingFee);
        setDiscount(calculatedDiscount);
        setDiscountPercentage(((calculatedTotalPrice - orderAmount) / calculatedTotalPrice) * 100);
    }, [orderAmount]);

    return (
        <div className=''>
            <p className='text-md font-semibold pb-4'>Price Details</p>
            <div className='space-y-3'>
                <div className='flex justify-between text-sm md:font-semibold '>
                    <p className='text-gray-500'>Total price</p>
                    <p className=''>+ ₹{totalPrice ? Number(totalPrice?.toFixed(2)) : 0}</p>
                </div>
                <div className='flex justify-between text-sm md:font-semibold'>
                    <p className='text-gray-500'>Pickup Charge</p>
                    <div className='flex gap-x-1'>
                        <p className='line-through'>₹{pickupCharge ? Number(pickupCharge?.toFixed(2)) : 0}</p>
                        <p className='text-green-500'>Free</p>
                    </div>
                </div>
                <div className='flex justify-between text-sm md:font-semibold'>
                    <p className='text-gray-500'>Handling Fee</p>
                    <div className='flex gap-x-1'>
                        <p className='line-through'>₹{handlingFee ? Number(handlingFee?.toFixed(2)) : 0}</p>
                        <p className='text-green-500'>Free</p>
                    </div>
                </div>
                {/* <div className='flex justify-between text-sm md:font-semibold'>
                    <p className='text-gray-500'>Total Discounts</p>
                    <div className='flex space-x-3'>
                        <p>- ₹{discount ? Number(discount?.toFixed(2)) : 0} </p>
                        <p className='text-gray-500'>{discountPercentage ? Number(discountPercentage?.toFixed(2)) : 0}% off</p>
                    </div>
                </div> */}
                <p className='border'></p>
                {!paymentModal &&
                    <div className='flex justify-between text-sm md:font-semibold'>
                        <p>Total Amount</p>
                        <p>₹{orderAmount ? Number(orderAmount?.toFixed(2)) : 0}</p>
                    </div>}
            </div>
        </div>
    );
};

export default PriceCalculator;







